import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";

const root = document.getElementsByClassName("estimation-loader")[0];

if (root) {
    const sitename = (root as HTMLElement).dataset.sitename;
    const startdate = (root as HTMLElement).dataset.startdate;
    const currentpaidsalary = (root as HTMLElement).dataset.currentpaidsalary;
    const currenttyelpayment = (root as HTMLElement).dataset.currenttyelpayment;
    const yearlypayment = (root as HTMLElement).dataset.yearlypayment;
    const yearlysalary = (root as HTMLElement).dataset.yearlysalary;
    const paymentpercent = (root as HTMLElement).dataset.paymentpercent;
    const company = (root as HTMLElement).dataset.company;
    const ytunnus = (root as HTMLElement).dataset.ytunnus;
    const customerrepresentative = (root as HTMLElement).dataset.customerrepresentative;

    const maintitle = (root as HTMLElement).dataset.maintitle;
    const customertitle = (root as HTMLElement).dataset.customertitle;
    const paymenttitle = (root as HTMLElement).dataset.paymenttitle;
    const customertext = (root as HTMLElement).dataset.customertext;
    const paymenttextupper = (root as HTMLElement).dataset.paymenttextupper;
    const paymenttextlower = (root as HTMLElement).dataset.paymenttextlower;
    const tablefirsttitle = (root as HTMLElement).dataset.tablefirsttitle;
    const tablesecondtitle = (root as HTMLElement).dataset.tablesecondtitle;
    const tablethirdtitle = (root as HTMLElement).dataset.tablethirdtitle;

    createRoot(root).render(
        <App
            sitename={sitename}
            startdate={startdate}
            currentpaidsalary={currentpaidsalary}
            currenttyelpayment={currenttyelpayment}
            yearlypayment={yearlypayment}
            yearlysalary={yearlysalary}
            paymentpercent={paymentpercent}
            company={company}
            ytunnus={ytunnus}
            customerrepresentative={customerrepresentative}

            maintitle={maintitle}
            customertitle={customertitle}
            paymenttitle={paymenttitle}
            customertext={customertext}
            paymenttextupper={paymenttextupper}
            paymenttextlower={paymenttextlower}
            tablefirsttitle={tablefirsttitle}
            tablesecondtitle={tablesecondtitle}
            tablethirdtitle={tablethirdtitle}
        />);
}
